/**
 * User Portal BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SearchReferralRewardHistoryResponse } from './search-referral-reward-history-response';


export interface SearchReferralRewardHistoryResponsePagedList { 
    totalCount?: number;
    items?: Array<SearchReferralRewardHistoryResponse> | null;
}

